import { Box, CircularProgress, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MicrosoftService } from '../../service/MicrosoftService';

let oauthCallbackStarted = false;

const MicrosoftOAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const [sending, setSending] = useState(true);

  useEffect(() => {
    if (oauthCallbackStarted) return;
    oauthCallbackStarted = true;

    const code = searchParams.get('code');
    const errorParam = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');

    if (errorParam) {
      setError(errorDescription || errorParam);
      setSending(false);
      setTimeout(() => window.close(), 2000);
      return;
    }

    if (!code) {
      setError('Missing authorization code');
      setSending(false);
      setTimeout(() => window.close(), 2000);
      return;
    }

    const run = async () => {
      try {
        await MicrosoftService.completeMicrosoftAuth(code);
        window.close();
      } catch {
        setError('Could not complete sign in. Please try again.');
        setSending(false);
      }
    };

    run();
  }, [searchParams]);

  if (error) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          gap: 2,
          p: 2,
        }}
      >
        <Typography color="error">{error}</Typography>
        <Typography sx={{ fontSize: '12px', color: 'text.secondary' }}>
          Closing window...
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        gap: 2,
      }}
    >
      <CircularProgress />
      <Typography color="text.secondary">
        {sending ? 'Completing sign in...' : 'Signing in with Microsoft...'}
      </Typography>
    </Box>
  );
};

export default MicrosoftOAuthCallback;
